import { Component, OnInit } from '@angular/core';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { ScheduleService } from 'src/app/services/schedule.service';
import { CaseService } from 'src/app/services/case.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { CookieService } from 'ngx-cookie-service';
import { IHearingDate } from '../shared/classes/hearing-date';
import { ApplicationStatusDto } from 'src/app/application/case/dto/application-status.dto';
import { ApplicationMinutesDto } from 'src/app/application/case/dto/application-minutes.dto';
import { ApplicationValueDto } from 'src/app/application/case/dto/application-value.dto';
import { DatePipe, formatCurrency } from '@angular/common';


@Component({
    selector: 'update-agenda',
    templateUrl: './update-agenda.component.html',
})

export class UpdateAgendaComponent implements OnInit {

    hearingDateList: any[]; // IHearingDate[];
    futureHearingDateList: any[]; // IHearingDate[];
    myHearing: IHearingDate;
    myHearingId = 0;
    myDate: Date;
    caseList: any[];
    selectedCases: any[];
    withdrawalCases: any[];

    myValueFinal: ApplicationValueDto;
    myCase: any;
    withdrawalsBy: '';

    cols: any[];
    dictionaryList: any;
    statusList: [];
    subStatusList: [];

    displayState: any = {
        workingDiv: false,
        gridDiv: false,
        caseListDiv: false,
        updateCasesDiv: false,
        saveDisabled: false,
        errorMessage: false,
        withdrawalsDiv: false,
    };

    filterOptions: any = {
        filterText: '',
    };

    hasRequiredData = true;

    constructor(private messageService: MessageService, private schedService: ScheduleService, private caseService: CaseService,
                private dictService: DictionaryService, private confirmationService: ConfirmationService, private datePipe: DatePipe,
                private utilService: UtilitiesService, private cookieService: CookieService) { }

    ngOnInit() {
        this.displayState.caseListDiv = false;
        this.cols = [
            { field: 'caseNum', header: 'Case #' },
            { field: 'applicantName', header: 'Applicant' },
            { field: 'status', header: 'Agenda Section' }
        ];
        this.dictionaryList = this.dictService.getDictionaries();
        this.statusList = this.dictionaryList.statusChoices;
        this.subStatusList = this.dictionaryList.subStatusChoices;

        this.getHearingDates();
    }

    // get list of defined Hearing Dates (for NON-FUTURE dates ONLY!)
    getHearingDates() {
        this.displayState.workingDiv = true;
        this.displayState.gridDiv = false;
        const tdy = new Date();
        this.schedService.getHearingDates().subscribe(data => {
            if (data) {
                this.hearingDateList = data.filter(t => {
                    const tHearDt = new Date(t.hearingDate);
                    return tHearDt > tdy ? null : t;
                });
                let mapped = this.hearingDateList.map(item => ({
                ...item,
                  hearingDateDesc: `${item.hearingDate.split('T')[0]} ${item.hearingTime}`
                }));
                this.hearingDateList = mapped;

                this.futureHearingDateList = data.filter(t => {
                    const tHearDt = new Date(t.hearingDate);
                    return tHearDt > tdy ? t : null;
                });
              mapped = this.futureHearingDateList.map(item => ({
                ...item,
                hearingDateDesc: `${item.hearingDate.split('T')[0]} ${item.hearingTime}`
              }));
              this.futureHearingDateList = mapped;
            }
            this.displayState.workingDiv = false;
            this.displayState.gridDiv = true;
            this.displayState.caseListDiv = false;
        });
    }

    // triggered when user selects a Hearing Date, to display cases scheduled on that date...
    onSelectHearing(hearing: IHearingDate) {
        // get the hearing date's data; from grid or from API call??
        //
        // now, display the case list form
        this.myHearing = hearing;
        this.myHearingId = hearing.id;
        // get list of cases scheduled for this hearing date
        this.getScheduledCases(hearing.id.toString());
        return true;
    }
    // get list of cases scheduled for selected Hearing Date
    getScheduledCases(hearingId: string) {
        this.displayState.caseListDiv = false;
        this.displayState.updateCasesDiv = false;
        this.schedService.getScheduledCases(hearingId).subscribe(data => {
            if (data) {
                this.caseList = data;
                this.updateAgendaSection();
            }
            this.selectedCases = [];
            this.displayState.caseListDiv = true;

        });
    }
    // update Agenda Section field of scheduled cases, based on each case's Status/Sub-Status values
    updateAgendaSection() {
        const needUpdateList = this.caseList;
        const n = needUpdateList.length;
        let agendaSection = '';
        for (let i = 0; i < n; i++) {
            agendaSection = 'Cases Not Noticed';
            if (needUpdateList[i].subStatus == 'Continuance Requested') {
                agendaSection = 'Continuance Requested';
            }

            if (needUpdateList[i].status == 'Noticed for Hearing' || needUpdateList[i].status == 'Continued Hearing') {
                if (needUpdateList[i].subStatus !== 'Stipulation Received' && needUpdateList[i].subStatus !== 'Withdrawal Received' && needUpdateList[i].subStatus !== 'Continuance Requested') {
                    agendaSection = 'Contested Matter';
                }
            }

            if (needUpdateList[i].status == 'Noticed for Insufficiency Hearing' || needUpdateList[i].status == 'Continued Hearing on Insufficiency') {
                agendaSection = 'Insufficiency Hearing';
            }

            if (needUpdateList[i].status == 'Noticed for Hearing on Late Filing' || needUpdateList[i].status == 'Continued Hearing on Late Filing') {
                agendaSection = 'Late Filing';
            }

            if (needUpdateList[i].status == 'Noticed for Res Status Conference' || needUpdateList[i].status == 'Continued Res Status Conference') {
                agendaSection = 'Res Status Conference';
            }

            if (needUpdateList[i].status == 'Noticed for Status Conference' || needUpdateList[i].status == 'Continued Status Conference') {
                agendaSection = 'Status Conference';
            }
            if (needUpdateList[i].status == 'Noticed for Reset Hearing') {
                agendaSection = 'Reset Hearing';
            }

          // tslint:disable-next-line:max-line-length
            if (needUpdateList[i].subStatus == 'Withdrawal Received' || needUpdateList[i].subStatus == 'Waiver Requested' || needUpdateList[i].subStatus == 'Stipulation Received' || needUpdateList[i].subStatus == 'Stipulation Pending') {
                agendaSection = needUpdateList[i].subStatus;
            }

            needUpdateList[i].agendaSection = agendaSection;
        }
        this.caseList = needUpdateList;

    }

    // determine if the case status is a Stipulation
    isStipulation(): boolean {
        if (this.myCase.status == 'Stipulation Approved') {
            return true;
        }
        return false;
    }

    // clear text from Motion By field
    clearMotionBy() {
        this.myCase.motionBy = '';
        this.saveLastMotionBy();
    }

    // called when user clicks on Update Cases button; enable form to enter/edit data to be applied to selected Cases
    updateCases() {
        this.myValueFinal = null;
        const myDate = new Date(this.myHearing.hearingDate).toLocaleDateString();
        this.myCase = {
            caseNum: this.selectedCases[0].caseNum,
            applicantName: this.selectedCases[0].applicantName,
            statusDate: myDate,
            status: '',
            subStatus: '',
            hearingDateIndex: '',
            hearingDate: '',
            hearingId: '',
            motionBy: '',
            minutesText: ''
        };
        this.getLastMotionBy(); // get the last Motion By text entered during this "session"
        const n = this.selectedCases.length;
        if (n == 1) {
            const appId = this.selectedCases[0].applicationId;
            this.getAPN(appId);
            this.getFinalValues(appId);
        } else if (n == 2) {
            this.myCase.caseNum = this.selectedCases[0].caseNum + ' and ' + this.selectedCases[1].caseNum;
            this.myCase.applicantName = this.selectedCases[0].applicantName + ' and ' + this.selectedCases[1].applicantName;
        } else {
            this.myCase.caseNum = this.selectedCases[0].caseNum + ' and others';
            this.myCase.applicantName = this.selectedCases[0].applicantName + ' and others';
        }
        this.displayState.gridDiv = false;
        this.displayState.caseListDiv = false;
        this.displayState.updateCasesDiv = true;
    }

    cancelUpdateCases() {
        this.selectedCases = [];    // clear selected cases so they won't be inadvertently updated again...
        this.displayState.updateCasesDiv = false;
        this.displayState.gridDiv = true;
        this.displayState.caseListDiv = true;
    }

    // validate update cases data
    validateUpdateCases(): boolean {
        if (this.myCase.status == '') {
            this.showToast({severity: 'error', detail: 'Please enter a Status.', summary: 'Missing Data'});
            return false;
        }
        const nextDateIndex = this.myCase.hearingDateIndex;
        let nextDate = '';
        const bHearingDateNeeded = this.needHearingDate(this.myCase.status);
        const bClosedStatus = this.closedStatus(this.myCase.status);
        if (nextDateIndex === '') {
            nextDate = '';
        } else {
            nextDate = this.futureHearingDateList[nextDateIndex].hearingDate;
        }
        const i = 0;
        const ct = this.selectedCases.length;
        // console.log('Closed Status: ' + bClosedStatus + '; Hearing Date Needed: ' + bHearingDateNeeded +'; nextDateIndex: ' + nextDateIndex + '; next Date: ' + nextDate)
        if (bHearingDateNeeded === true && !nextDate ) {
            this.showToast({severity: 'error', detail: 'This Status requires a Hearing date.', summary: 'Missing Data'});
            return false;
        }

        if (bClosedStatus === true && this.myCase.subStatus) {
            this.showToast({severity: 'error', detail: 'Closed Status--No Sub-Status permitted.', summary: 'Invalid Data'});
            this.myCase.subStatus = '';
            return false;
        }
        // if one case and status is AAB, it needs AB Valuation values...
        if ( ct === 1 && (this.needValues(this.myCase.status) === true) && (this.hasValues() === false) ) {
            this.showToast({severity: 'error', detail: 'This Status requires Appeals Board Valuation values.', summary: 'Missing Data'});
            return false;
        }

        if (nextDate) {
            if (bHearingDateNeeded === false) {
                // this should include Closed statuses
                this.showToast({severity: 'error', detail: 'Hearing Date not permitted for this Status.', summary: 'Invalid Data'});
                return false;
            }
            /*
            else if (bClosedStatus === true) {
                this.showToast({severity: 'error', detail: 'Closed Status - Hearing Date not permitted for this Status.', summary: 'Invalid Data'});
                return false;
            }*/
        }
        // passed all tests, so we should be OK to proceed...
        return true;
    }

    // update DB for selected cases...
    executeUpdateCases() {
        // validate data entered...
        if (this.validateUpdateCases() === false) { return; }
        //
        // ****NOTE: should we display "Processing..." message while doing saving??
        this.displayState.workingDiv = true;
        //
        if (this.isStipulation()=== true) {
          this.saveLastMotionBy();  // save the Motion By, for later retrieval
        }
        const theStatusDate = new Date(this.myHearing.hearingDate);
        const nextDateIndex = this.myCase.hearingDateIndex;
        let nextDate = '';
        let nextHearingId = 0;
        let aStatus: ApplicationStatusDto;
        let aMinute: ApplicationMinutesDto;
        const xHearingId = this.myHearing.id;
        const xApplicationId = this.selectedCases[0].applicationId;
        if (nextDateIndex !== '') {
            nextDate = this.futureHearingDateList[nextDateIndex].hearingDate;
            nextHearingId = this.futureHearingDateList[nextDateIndex].id;
        }
        // console.log('continue w/ saving...');

        let i = 0, ct = 0;
        ct = this.selectedCases.length;

        // first update Values (if only ONE case was selected) and Minutes
        aMinute = {
            id: 0,
            applicationId: 0,
            applicationIds: [],
            hearingId: xHearingId,
            minutesNote: this.myCase.minutesText,
            hearingDate: theStatusDate,
        };
        if (ct === 1) {
            if (this.hasValues()) {
                this.saveValues(xApplicationId, this.myValueFinal);
            }
            if (this.myCase.minutesText !== '') {
                aMinute.applicationId = xApplicationId;
                this.caseService.saveHearingMinutes(aMinute).subscribe(data => {
                    // console.log('saveHearingMinutes response: ' + data);
                });
            }
        } else {
            // more than one selected Case, so only save Batch Minutes (coz no Values will have been collected)
            if (this.myCase.minutesText !== '' ){
                for (i = 0; i < ct; i++){
                    aMinute.applicationIds.push(this.selectedCases[i].applicationId);
                }
                this.caseService.saveBatchHearingMinutes(aMinute).subscribe(data => {
                    // console.log('saveBatchHearingMinutes response');
                    if (data) {
                        // console.log(data);
                    }
                });
            }
        }

        // now insert new status
        aStatus = {
            id: 0,
            applicationId: 0,
            applicationIds: [],
            status: this.myCase.status,
            subStatus: this.myCase.subStatus,
            hearingDate: null,
            hearingId: nextHearingId,
            statusDate: theStatusDate
        };
        // {"id":1,"applicationId":2,"statusDate":"2020-03-25T22:41:39.7554844+00:00","status":"sample string 4","subStatus":"sample string 5","hearingId":6,"hearingDate":"2020-03-25T22:41:39.7554844+00:00"}
        if (ct === 1) {
            aStatus.applicationId = xApplicationId;
        } else {
            aStatus.applicationIds = [];
            for (i = 0; i < ct; i++){
                aStatus.applicationIds.push(this.selectedCases[i].applicationId);
            }
        }
        /*
        aStatus.statusDate = theStatusDate;
        aStatus.status = this.myCase.status;
        aStatus.subStatus = this.myCase.subStatus;
        aStatus.hearingId = xHearingId;
        */
        // console.log(aStatus);
        if (ct === 1) {
            this.caseService.saveCaseStatus(aStatus).subscribe(data => {
                // console.log('saveAppStatus response');
                if (data) {
                    // console.log(data);
                }
                this.resetUpdateCaseDisplay();
        });
        } else {
            this.caseService.saveBatchAppStatus(aStatus).subscribe(data => {
                // console.log('saveBatchAppStatus response');
                if (data) {
                    // console.log(data);
                }
                this.resetUpdateCaseDisplay();
            });
        }
        //
    }

    // reset CaseList display (after updating cases)
    resetUpdateCaseDisplay() {
        this.selectedCases = [];    // clear selected cases so they won't be inadvertently updated again...
        this.displayState.updateCasesDiv = false;
        this.displayState.gridDiv = true;
        // refresh cases here...
        this.getScheduledCases(this.myHearingId.toString());
        this.displayState.workingDiv = false;
        // this.displayState.caseListDiv = true;
        //

    }

    saveValues(appId: string, myValues: ApplicationValueDto) {
        this.caseService.saveCaseValueGroup(appId, 'final', myValues).subscribe(data => {
            // console.log('saveValues (final) response');
            if (data) {
                // console.log(data);
            }
        });
    }

    // get Valuation values (if only ONE case was selected!)
    getFinalValues(applicationId: string) {
        this.caseService.getValueGroup(applicationId, 'final').subscribe(data => {
            if (data) {
                this.utilService.doAudit(data, 'final values:');
                // {"id":17512,"fixturesValue":0.00,"improveValue":0.00,"landValue":0.00,"mineralValue":0.00,"personalValue":0.00,"treesValue":0.00,"totalValue":0.00,"exemptValue":0.00,"netValue":0.00,"penaltyValue":0.00}
                this.myValueFinal = data;
                if (data.fixturesValue > 0 || data.improveValue > 0 || data.landValue > 0 || data.mineralValue > 0 || data.personalValue > 0 || data.treesValue > 0 || data.penaltyValue > 0 || data.exemptValue > 0 || data.totalValue > 0) {
                    this.formatInitValues();
                    // this.calcValues();
                }
                // console.log("myValueFinal: " + this.caseId);
            }
        });
    }

    // get Assessed values
    getAssessorValues() {
        const applicationId = this.selectedCases[0].applicationId;
        // console.log('getting assessed values for appId: ' + applicationId);
        this.caseService.getValueGroup(applicationId, 'assessor').subscribe(data => {
            if (data) {
                // console.log(data);
                // {"id":17512,"fixturesValue":0.00,"improveValue":0.00,"landValue":0.00,"mineralValue":0.00,"personalValue":0.00,"treesValue":0.00,"totalValue":0.00,"exemptValue":0.00,"netValue":0.00,"penaltyValue":0.00}
                if (data.fixturesValue > 0 || data.improveValue > 0 || data.landValue > 0 || data.mineralValue > 0 || data.personalValue > 0 || data.treesValue > 0 || data.penaltyValue > 0 || data.exemptValue > 0 || data.totalValue > 0) {
                    this.myValueFinal = data;
                    this.calcValues();
                    this.showToast({severity: 'success', detail: 'Assessor values were retrieved.', summary: 'Info'});
                } else {
                    this.getApplicantValues(applicationId); // get Applicant valuations...
                }
            }
        });
    }

    // get Applicant-supplied valuations, if available
    getApplicantValues(applicationId: string) {
        this.confirmationService.confirm({
            message: 'No Assessor values are available. \nDo you want to retrieve Applicant supplied values?',
            header: 'Retrieve Values',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.caseService.getValueGroup(applicationId, 'applicant').subscribe(data => {
                    if (data) {
                        // console.log(data);
                        if (data.fixturesValue > 0 || data.improveValue > 0 || data.landValue > 0 || data.mineralValue > 0 || data.personalValue > 0 || data.treesValue > 0 || data.penaltyValue > 0 || data.exemptValue > 0 || data.totalValue > 0) {
                            this.myValueFinal = data;
                            this.calcValues();
                            this.showToast({severity: 'success', detail: 'Applicant values were retrieved.', summary: 'Info'});
                        } else {
                            this.showToast({severity: 'error', detail: 'Applicant values are NOT available.', summary: 'Info'});
                        }
                        // console.log("myValueFinal: " + this.caseId);
                    }
                });
            },
            reject: () => {
                this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
            }
        });
    }

    getAPN(applicationId: string) {
        this.caseService.getCaseProperty(applicationId).subscribe(data => {
            if (data) {
                this.myCase.APN = data.apn;
            }
        });
    }

    // view all requests for withdrawals (i.e. applications with a "Withdrawal Received" status) present on this Hearing Date, if any
    viewWithdrawals() {
        const theStatusDate = new Date(this.myHearing.hearingDate);
        let aStatus: ApplicationStatusDto ;
        let aMinute: ApplicationMinutesDto;
        const withdrawalAppIds = [];
        let i = 0, n = 0, hits = 0;

        n = this.caseList.length;
        this.withdrawalCases = [];
        // console.log('# of Cases: ' + n);
        for (i = 0; i < n; i++) {
            if (this.caseList[i].agendaSection === 'Withdrawal Received') {
                hits++;
                // withdrawalAppIds.push(this.selectedCases[i].applicationId);
                this.withdrawalCases.push(this.caseList[i]);
            }
        }
        if (hits === 0) {
            this.showToast({severity: 'info', detail: 'No withdrawals on this date.', summary: 'Warning'});
            return;
        }
        this.utilService.doAudit(hits, '# of withdrawals:');
        this.displayState.gridDiv = false;
        this.displayState.caseListDiv = false;
        this.withdrawalsBy = '';
        this.displayState.withdrawalsDiv = true;
    }

    // update qualifying applications (i.e. add Minutes and new Status)
    updateWithdrawals() {
        // ***NOTE:  make WithdrawalBy REQUIRED??
        const theStatusDate = new Date(this.myHearing.hearingDate);
        let aStatus: ApplicationStatusDto ;
        let aMinute: ApplicationMinutesDto;
        const withdrawalAppIds = [];
        let i = 0, n = 0;
        n = this.withdrawalCases.length;
        for (i = 0; i < n; i++){
            withdrawalAppIds.push(this.withdrawalCases[i].applicationId);
        }
        // console.log('appIds accepting withdrawals: ' + withdrawalAppIds);
        // First save batch minutes "Accepted Withdrawal"
        aMinute = {
            id: 0,
            applicationId: 0,
            hearingId: this.myHearing.id,
            minutesNote: 'Accepted Withdrawal',
            hearingDate: theStatusDate,
            applicationIds: withdrawalAppIds,
        };
        if (this.withdrawalsBy) {
            aMinute.minutesNote = this.withdrawalsBy + ': ' + aMinute.minutesNote;
        }
        // console.log(aMinute);
        //
        this.caseService.saveBatchHearingMinutes(aMinute).subscribe(data => {
            if (data) {
                // console.log('saveBatchHearingMinutes response');
                // console.log(data);
            } else {
                this.showToast({severity: 'error', detail: 'Error saving Minutes.', summary: 'Error'});
            }
        });
        // Now insert the new Status
        // ***NOTE:  should saving Statuses be conditional on saving Minutes??
        aStatus = {
            id: 0,
            applicationId: null,
            applicationIds: withdrawalAppIds,
            statusDate: theStatusDate,
            status: 'Withdrawal Approved',
            subStatus: '',
            hearingId: 0, // was originally null; changed 6/29/2022
            hearingDate: theStatusDate
        };
        // console.log(aStatus);
        this.caseService.saveBatchAppStatus(aStatus).subscribe(data => {
            if (data) {
                // console.log('saveBatchAppStatus response');
                // console.log(data);

            } else {
                this.showToast({severity: 'error', detail: 'Error saving Statuses.', summary: 'Error'});
            }
            // reset all relevant page fields, refresh the list of scheduled cases...
            this.withdrawalsBy = '';
            this.withdrawalCases = [];
            this.displayState.withdrawalsDiv = false;
            this.displayState.gridDiv = true;
            this.getScheduledCases(this.myHearingId.toString());   // refresh the case list associated w/ the selected Hearing Date...
        });
    }

    cancelWithdrawals() {
        this.displayState.withdrawalsDiv = false;
        this.displayState.gridDiv = true;
        this.withdrawalCases = [];
        this.withdrawalsBy = '';
        this.displayState.caseListDiv = true;
    }
    // prepare Minutes text, based on details entered (i.e. Status/sub-Status, Hearing Date, etc)
    prepMinutesText() {
        // console.log('hearing date: ' + this.myCase.hearingDateIndex);
        const xStatus = this.myCase.status;
        if (!xStatus) {
            this.showToast({severity: 'error', detail: 'Please enter a Status.', summary: 'Missing Data'});
            return;
        }
        const xSubStatus = this.myCase.subStatus;
        const pieces = xStatus.split(' ');
        let x = '';
        if (pieces[0] === 'Continued') {
            if (this.myCase.hearingDateIndex === '') {
                this.showToast({ severity: 'error', detail: 'Please specify the next Hearing Date.', summary: 'Missing Data' });
                return;
            }
            const myDate = new Date(this.futureHearingDateList[this.myCase.hearingDateIndex].hearingDate).toLocaleDateString();
            x = xStatus + ' to ' +  myDate;
            if (xSubStatus === 'Stipulation Pending'){
                x = xSubStatus + '.  ' + x;
            }
        }
        if (xStatus === 'Denied - No Show'){
            x = 'Denied for lack of appearance, subject to resetting for ';
            x = x + 'good cause shown if request for reconsideration is sent ';
            x = x + 'within 60 days from the date of mailing of the notification.';
        }

        if (xStatus === 'Stipulation Approved') {
            if (this.selectedCases.length > 1) {
                this.showToast({severity: 'error', detail: 'Cannot generate Minutes Text for this Status when more than 1 case selected.', summary: 'Invalid Command'});
                return;
            }
            if (this.myCase.motionBy === '') {
                this.showToast({severity: 'error', detail: 'Please enter Motion By.', summary: 'Missing Data'});
                return;
            }
            if (!this.hasValues()) {
                this.showToast({severity: 'error', detail: 'Please enter valuation(s)', summary: 'Missing Data'});
                return;
            }
            x = this.myCase.motionBy + ': Approved the stipulation as to value in the matter of Application for Reduction No. ';
            x = x + this.myCase.caseNum + ', Assessor\'s Parcel No. ' + this.formatAPN(this.myCase.APN) ;
            x = x + ', entered into between the assessor and (applicant or agent) be approved, ';
            x = x + 'that the full cash value under subdivision (a) of section 2 of article XIIIA ';
            x = x + 'of the California Constitution for said parcel be set at ' + this.formatTotalValue();
            x = x + ' as provided in said stipulation, and that the appearance of (person affected or ';
            x = x + 'agent) be deemed waived.';
        }
        this.myCase.minutesText = x;
        if (x.length == 0) {
            this.showToast({severity: 'info', detail: 'Based on data entered, no Minutes text was generated', summary: ''});
        }
    }

    formatAPN(myAPN: string): string {
        const apn = myAPN;
        let result = '';
        if (apn.match(/[^0-9]/)) {
            return apn;
        }
        if (apn.length === 9) {
            result = apn.slice(0, 3) + '-' + apn.slice(3, 6) + '-' + apn.slice(6);
        }
        if (result !== '') {
            return result;
        } else {
            return apn;
        }
    }

    formatTotalValue(): string {
        let tot = 0;
        let amt;
        // strip commas to sum values
        amt = this.stripCommas(this.myValueFinal.landValue);
        if (isNaN(amt) === false) { tot = +amt + tot; }
        amt = this.stripCommas(this.myValueFinal.mineralValue);
        if (isNaN(amt) === false) { tot = +amt + tot; }
        amt = this.stripCommas(this.myValueFinal.improveValue);
        if (isNaN(amt) === false) { tot = +amt + tot; }
        amt = this.stripCommas(this.myValueFinal.treesValue);
        if (isNaN(amt) === false) { tot = +amt + tot; }
        amt = this.stripCommas(this.myValueFinal.fixturesValue);
        if (isNaN(amt) === false) { tot = +amt + tot; }
        amt = this.stripCommas(this.myValueFinal.personalValue);
        if (isNaN(amt) === false) { tot = +amt + tot; }
        if (tot === 0) {
            amt = this.stripCommas(this.myValueFinal.netValue);
            if (isNaN(amt) === false) { tot = +amt; }
        }
        return formatCurrency(tot, 'en', '$', '', '1.0-0');
    }

    // (re)calculate Total and Net values, based on user input
    calcValues() {
        let tot = 0, net = 0;
        let amt;
        // strip commas to sum values
        amt = this.stripCommas(this.myValueFinal.landValue);
        if (isNaN(amt) === false) { tot = +amt + tot; }
        amt = this.stripCommas(this.myValueFinal.mineralValue);
        if (isNaN(amt) === false) { tot = +amt + tot; }
        amt = this.stripCommas(this.myValueFinal.improveValue);
        if (isNaN(amt) === false) { tot = +amt + tot; }
        amt = this.stripCommas(this.myValueFinal.treesValue);
        if (isNaN(amt) === false) { tot = +amt + tot; }
        amt = this.stripCommas(this.myValueFinal.fixturesValue);
        if (isNaN(amt) === false) { tot = +amt + tot; }
        amt = this.stripCommas(this.myValueFinal.personalValue);
        if (isNaN(amt) === false) { tot = +amt + tot; }
        if (tot === 0) {
            amt = this.stripCommas(this.myValueFinal.netValue);
            if (isNaN(amt) === false) { tot = +amt; }
        }
        this.myValueFinal.totalValue = tot;
        // *** AS OF 6/27/2022 - do NOT calculate NetTotal (coz it's not implemented in legacy, SB, system)
        // this.myValueFinal.netValue = net;
        // net = tot - (+this.stripCommas(this.myValueFinal.penaltyValue) + +this.stripCommas(this.myValueFinal.exemptValue));
        // this.myValueFinal.netValue = this.utilService.thouSeparator(net);
        // console.log('Total: ' + tot + '; net: ' + net);
    }

    stripCommas(aVal) {
        let cleanVal = 0;
        if (aVal !== null && aVal !== undefined) {
            cleanVal = aVal.toString().replace(/,/g, '');
        }
        return cleanVal;
    }

    formatInitValues() {
        // format initial Final values
        for (let i = 0; i < 9; i++) {
            this.addCommas(i, true);
        }
    }

    addCommas(myNum: number, isInitValue: boolean = false) {
        // user has left the input element...
        // calculate the totals, but only if the change initiated w/ the user coz on the call from ngOnInit, some of the objects won't be present...
        // if (fromTemplate) { this.calculateTotalValue(); }
        this.calcValues();
        //
        // add the commas to the field we just left...
        let myVal: any;
        // let myCateg = Math.trunc(myNum / 10);
        const myCateg = +myNum;
        // let mySource = +myNum % 10;
        if (myCateg == 0) { // Land Values
            myVal = this.myValueFinal.landValue;
            this.myValueFinal.landValue = this.utilService.thouSeparator(myVal);
        } else if (myCateg == 1) {  // improvements
            myVal = this.myValueFinal.improveValue;
            this.myValueFinal.improveValue = this.utilService.thouSeparator(myVal);
        } else if (myCateg == 2) {  // fixtures
            myVal = this.myValueFinal.fixturesValue;
            this.myValueFinal.fixturesValue = this.utilService.thouSeparator(myVal);
        } else if (myCateg == 3) {  // personal property
            myVal = this.myValueFinal.personalValue;
            this.myValueFinal.personalValue = this.utilService.thouSeparator(myVal);
        } else if (myCateg == 4) {  // mineral rights
            myVal = this.myValueFinal.mineralValue;
            this.myValueFinal.mineralValue = this.utilService.thouSeparator(myVal);
        } else if (myCateg == 5) {  // trees and vines
            myVal = this.myValueFinal.treesValue;
            this.myValueFinal.treesValue = this.utilService.thouSeparator(myVal);
        } else if (myCateg == 6) {  // exemptions
            myVal = this.myValueFinal.exemptValue;
            this.myValueFinal.exemptValue = this.utilService.thouSeparator(myVal);
        } else if (myCateg == 7) {  // penalties
            myVal = this.myValueFinal.penaltyValue;
            this.myValueFinal.penaltyValue = this.utilService.thouSeparator(myVal);
        } else if (myCateg == 8) {  // net totals
            myVal = this.myValueFinal.netValue;
            this.myValueFinal.netValue = this.utilService.thouSeparator(myVal);
        }
      }

      removeCommas(myNum: number) {
        // when user is doing input, we remove commas
        this.utilService.doAudit(myNum, 'removing commas for:');
        // let myCateg = Math.trunc(myNum / 10);
        const myCateg = +myNum;
        // let mySource = +myNum % 10;
        if (myCateg === 0) {  // land values
            this.myValueFinal.landValue = this.stripCommas(this.myValueFinal.landValue);
        } else if (myCateg == 1) {  // improvements
            this.myValueFinal.improveValue = this.stripCommas(this.myValueFinal.improveValue);
        } else if (myCateg == 2) {  // fixtures
            this.myValueFinal.fixturesValue = this.stripCommas(this.myValueFinal.fixturesValue);
        } else if (myCateg == 3) {  // personal property
            this.myValueFinal.personalValue = this.stripCommas(this.myValueFinal.personalValue);
        } else if (myCateg == 4) {  // mineral rights
            this.myValueFinal.mineralValue = this.stripCommas(this.myValueFinal.mineralValue);
        } else if (myCateg == 5) {  // trees and vines
            this.myValueFinal.treesValue = this.stripCommas(this.myValueFinal.treesValue);
        } else if (myCateg == 6) {  // exemptions
            this.myValueFinal.exemptValue = this.stripCommas(this.myValueFinal.exemptValue);
        } else if (myCateg == 7) {  // penalties
            this.myValueFinal.penaltyValue = this.stripCommas(this.myValueFinal.penaltyValue);
        } else if (myCateg == 8) {  // net totals
            this.myValueFinal.netValue = this.stripCommas(this.myValueFinal.netValue);
        }
      }

    hasValues(): boolean {
        if (!this.myValueFinal) { return false; }
        if (this.myValueFinal.fixturesValue > 0 || this.myValueFinal.improveValue > 0 || this.myValueFinal.landValue > 0 || this.myValueFinal.mineralValue > 0 || this.myValueFinal.personalValue > 0 || this.myValueFinal.treesValue > 0 || this.myValueFinal.penaltyValue > 0 || this.myValueFinal.exemptValue > 0 || this.myValueFinal.totalValue > 0) {
            return true;
        }
        return false;
    }

    needHearingDate(xStatus: string): boolean {
        const pieces = xStatus.split(' ');
        if (pieces[0] === 'Scheduled') { return true; }
        if (pieces[0] === 'Waiver') { return true; }
        if (pieces[0] === 'Continued') { return true; }
        if (pieces[0] === 'Noticed') { return true; }
        return false;
    }

    closedStatus(xStatus: string): boolean {
        const pieces = xStatus.split(' ');
        if (pieces[0] === 'Withdrawal') { return true; }
        if (pieces[0] === 'AAB') { return true; }
        if (pieces[0] === 'Denied') { return true; }
        if (pieces[0] === 'Stipulation') { return true; }
        return false;
    }

    needValues(xStatus: string): boolean {
        const pieces = xStatus.split(' ');
        // if (pieces[0] === 'Denied') { return true; }
        // if (xStatus === 'AAB Determined Value') { return true; }
        // per Lia G, no status requires values to be entered - as of 4/3/2025 rod
        return false;
    }
    getLastMotionBy(): void {
      const obj = localStorage.getItem('update-agenda-lastMotionBy');
      this.utilService.doAudit(obj, 'stringified Motion By obj:');
      if (obj) {
        this.myCase.motionBy = obj; // JSON.parse(obj);
      }
    }

    saveLastMotionBy() {
      localStorage.setItem('update-agenda-lastMotionBy', this.myCase.motionBy); // username included to make it unique to user
    }
    showToast(msg: Message) {
      this.messageService.add(msg);
    }
    showConfirm() {
      this.messageService.clear();
      this.messageService.add({key: 'c', sticky: true, severity: 'warn', summary: 'Are you sure?', detail: 'Confirm to proceed'});
    }
    onConfirm() {
      this.messageService.clear('c');
    }
    onReject() {
      this.messageService.clear('c');
    }

    clear() {
    this.messageService.clear();
    }

    getLastMotionByNEW() {
      const motionBy = this.cookieService.get('update-agenda-lastMotionBy');
      if (motionBy) {
        this.myCase.motionBy = motionBy;
      }
    }
    saveLastMotionByNEW() {
      this.cookieService.set('update-agenda-lastMotionBy', this.myCase.motionBy, 1, '/');
    }
}
